module.exports = require("@swa-ui/personal-info/src/form/PassengerAccommodationsFormFields/OtherAssistanceFormFields/OtherAssistanceFormFields.module.scss");